(()=>{
  const ready=()=>{
    const root=document.documentElement;
    const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
    const isReduced=()=>!!(reduced&&reduced.matches);

    /* V5.5: restore the proven V5.2 Quick Routes contract exactly. */
    const q=document.querySelector('[data-ecz52-quick]');
    if(q){
      const t=q.querySelector('[data-ecz52-trigger]');
      const p=q.querySelector('[data-ecz52-panel]');
      const c=q.querySelector('[data-ecz52-close]');
      const f=q.querySelector('[data-ecz52-filter]');
      const s=q.querySelector('[data-ecz52-count]');
      const top=q.querySelector('[data-ecz52-top]');

      const filter=()=>{
        if(!f||!p)return;
        const needle=f.value.trim().toLowerCase();
        let visible=0;
        p.querySelectorAll('[data-ecz52-route]').forEach(a=>{
          const show=!needle||(a.textContent||'').toLowerCase().includes(needle);
          a.hidden=!show;
          if(show) visible+=1;
        });
        p.querySelectorAll('[data-ecz52-group]').forEach(g=>{
          g.hidden=![...g.querySelectorAll('[data-ecz52-route]')].some(a=>!a.hidden);
        });
        if(s) s.textContent=needle?`${visible} route${visible===1?'':'s'} shown`:'Search routes or choose a group.';
      };
      const open=()=>{
        if(!t||!p)return;
        p.hidden=false;
        t.setAttribute('aria-expanded','true');
        requestAnimationFrame(()=>f&&f.focus());
      };
      const close=(restoreFocus=true)=>{
        if(!t||!p)return;
        p.hidden=true;
        t.setAttribute('aria-expanded','false');
        if(f){f.value='';filter();}
        if(restoreFocus) t.focus();
      };

      t&&t.addEventListener('click',()=>p&&p.hidden?open():close(false));
      c&&c.addEventListener('click',()=>close());
      f&&f.addEventListener('input',filter);
      document.addEventListener('keydown',e=>{if(e.key==='Escape'&&p&&!p.hidden)close();});
      document.addEventListener('pointerdown',e=>{if(p&&!p.hidden&&!q.contains(e.target))close(false);});
      q.querySelectorAll('[data-ecz52-route]').forEach(a=>a.addEventListener('click',()=>close(false)));

      const toggleTop=()=>{if(top) top.hidden=window.scrollY<520;};
      window.addEventListener('scroll',toggleTop,{passive:true});
      top&&top.addEventListener('click',()=>window.scrollTo({top:0,behavior:isReduced()?'auto':'smooth'}));
      toggleTop();
      filter();

      /* Keep the compact utility dock above the footer without covering proof/legal content. */
      const footer=document.querySelector('[data-ecz54-footer]');
      if(footer){
        let raf=0;
        const base=()=>window.matchMedia('(max-width:820px)').matches?12:14;
        const place=()=>{
          raf=0;
          const r=footer.getBoundingClientRect();
          const overlap=(r.top<window.innerHeight&&r.bottom>0)?Math.max(0,window.innerHeight-r.top):0;
          q.style.setProperty('--ecz55-dock-bottom',`${Math.round(base()+overlap)}px`);
        };
        const schedule=()=>{if(!raf) raf=requestAnimationFrame(place);};
        window.addEventListener('scroll',schedule,{passive:true});
        window.addEventListener('resize',schedule,{passive:true});
        if('ResizeObserver' in window) new ResizeObserver(schedule).observe(footer);
        place();
      }
    }

    /* Signature home-page sequence: slow, sequential raise + highlight, then repeat. */
    const seq=document.querySelector('[data-ecz52-sequence]');
    if(seq){
      const steps=[...seq.querySelectorAll('[data-ecz52-step]')];
      if(steps.length){
        let i=-1,timer=0,paused=false;
        const clear=()=>steps.forEach(el=>{el.classList.remove('is-active');el.removeAttribute('aria-current');});
        const show=n=>{
          clear();
          if(n>=0&&n<steps.length){
            steps[n].classList.add('is-active');
            steps[n].setAttribute('aria-current','step');
          }
          i=n;
        };
        const schedule=delay=>{window.clearTimeout(timer);timer=window.setTimeout(tick,delay);};
        const tick=()=>{
          if(paused||isReduced()) return;
          if(i<steps.length-1){show(i+1);schedule(2400);}
          else{show(-1);schedule(800);}
        };
        const start=()=>{
          window.clearTimeout(timer);
          if(isReduced()){show(-1);return;}
          show(-1);
          schedule(550);
        };
        seq.addEventListener('pointerenter',()=>{paused=true;window.clearTimeout(timer);});
        seq.addEventListener('pointerleave',()=>{paused=false;schedule(600);});
        seq.addEventListener('focusin',()=>{paused=true;window.clearTimeout(timer);});
        seq.addEventListener('focusout',()=>{paused=false;schedule(600);});
        if(reduced){
          if(reduced.addEventListener) reduced.addEventListener('change',start);
          else if(reduced.addListener) reduced.addListener(start);
        }
        start();
      }
    }

    /* Restore the actual Accountability Chain DOM contract used by the theme. */
    document.querySelectorAll('[data-ecz52-chain]').forEach(chain=>{
      const items=[...chain.querySelectorAll('li')];
      const note=chain.parentElement&&chain.parentElement.querySelector('[data-ecz52-chainnote]');
      if(!items.length)return;
      let pinned=-1;
      const paint=index=>{
        chain.classList.toggle('has-focus',index>=0);
        items.forEach((li,j)=>{
          li.classList.toggle('is-active',j===index);
          li.classList.toggle('is-near',index>=0&&Math.abs(j-index)<=2);
        });
        if(note) note.textContent=index>=0?(items[index].dataset.desc||'Select a stage to see its immediate accountability context.'):'Focus or select a stage to trace its adjacent accountability context.';
      };
      items.forEach((li,index)=>{
        const b=li.querySelector('button');
        if(!b)return;
        b.addEventListener('focus',()=>paint(index));
        b.addEventListener('mouseenter',()=>{if(pinned<0)paint(index);});
        b.addEventListener('click',()=>{pinned=pinned===index?-1:index;paint(pinned);});
        b.addEventListener('keydown',e=>{if(e.key==='Escape'){pinned=-1;paint(-1);b.blur();}});
      });
      chain.addEventListener('mouseleave',()=>{if(pinned<0)paint(-1);});
      chain.addEventListener('focusout',e=>{if(pinned<0&&!chain.contains(e.relatedTarget))paint(-1);});
      paint(-1);
    });

    /* Restrained one-time entry motion for significant information and decision objects. */
    const targets=[...document.querySelectorAll('.ecz53-freecard,.eczgm2-products article,.eczgm2-stakeholders a,.eczgm2-proof__grid,.ecz52-boundary5 article,.eczgm2-btns,.ecz52-passport,.ecz52-routeblock,.eczgm2-card,.eczgm2-boundary article,.eczgm2-jobs article')];
    if(targets.length){
      targets.forEach((el,index)=>{
        el.classList.add('ecz55-entry');
        el.style.setProperty('--ecz55-delay',`${(index%4)*55}ms`);
      });
      root.classList.add('ecz55-motion-ready');
      if(isReduced()||!('IntersectionObserver' in window)){
        targets.forEach(el=>el.classList.add('is-visible'));
      }else{
        const io=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
        targets.forEach(el=>io.observe(el));
      }
    }

    document.querySelectorAll('.eczgm2-mobile').forEach(d=>{
      d.addEventListener('keydown',e=>{if(e.key==='Escape'&&d.open){d.open=false;d.querySelector('summary')?.focus();}});
      d.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{d.open=false;}));
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',ready,{once:true}):ready();
})();